package org.example.project.enginekalender

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun KalenderDayField(
    label: String,
    isCurrentMonth: Boolean,
    isToday: Boolean,
    hasDayBorder: Boolean,
    cellSizePx: Int,
    fontSizePx: Int,
    borderRadiusPx: Int,
    hasBooking: Boolean = false,
    bookingColor: CSSColorValue,
    onClick: () -> Unit
) {
    var isHovered by remember { mutableStateOf(false) }
    Button(attrs = {
        style {
            width(cellSizePx.px)
            height(cellSizePx.px)
            padding(0.px)
            borderRadius(borderRadiusPx.px)
            backgroundColor(Color.transparent)
            property(
                "border",
                if (isToday || isHovered) "1px solid rgba(255,255,255,0.72)" else if (hasDayBorder) "1px solid rgba(255,255,255,0.22)" else "1px solid transparent"
            )
            color(
                when {
                    isToday -> Color.white
                    hasBooking -> Color.white
                    isCurrentMonth -> Color.white
                    else -> Color("rgba(255,255,255,0.38)")
                }
            )
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center)
            fontSize(fontSizePx.px)
            fontWeight("600")
            boxSizing("border-box")
            cursor("pointer")
            position(Position.Relative)
            property("z-index", "1")
            property(
                "box-shadow",
                if (isToday || isHovered) "0 0 0 1px rgba(255,255,255,0.10)" else if (hasDayBorder) "0 0 0 1px rgba(255,255,255,0.04)" else "none"
            )
        }
        onMouseEnter { isHovered = true }
        onMouseLeave { isHovered = false }
        onClick { onClick() }
    }) {
        Text(label)
        if (hasBooking) {
            Span({
                style {
                    position(Position.Absolute)
                    bottom(5.px)
                    left(50.percent)
                    width(5.px)
                    height(5.px)
                    borderRadius(50.percent)
                    backgroundColor(bookingColor)
                    property("transform", "translateX(-50%)")
                    property("box-shadow", "0 0 8px currentColor")
                    color(bookingColor)
                }
            })
        }
    }
}
